import { KeyConstants } from './enums';

export const keyCheck = (key: string): boolean =>
  [KeyConstants.ENTER, KeyConstants.SPACE].includes(key as KeyConstants);

export const keyCheckForNav = (key: string): boolean =>
  [KeyConstants.LEFT_NAV, KeyConstants.RIGHT_NAV].includes(key as KeyConstants);
